module.exports = __webpack_public_path__ + "media/mek2.fd551a64.webm";